import { render, staticRenderFns } from "./Add_texure.vue?vue&type=template&id=0ad3a5b4&"
import script from "./Add_texure.vue?vue&type=script&lang=js&"
export * from "./Add_texure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports